import { render } from "./chatBox.vue?vue&type=template&id=2b9cf1fe&scoped=true"
import script from "./chatBox.vue?vue&type=script&lang=js"
export * from "./chatBox.vue?vue&type=script&lang=js"

import "./chatBox.vue?vue&type=style&index=0&id=2b9cf1fe&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b9cf1fe"]])

export default __exports__